(function () {
  var desktop = window.matchMedia('(min-width: 1024px)');
  var ACTIVE_ARROW = ['text-primary', 'translate-x-0'];
  var IDLE_ARROW = ['text-muted-foreground', '-translate-x-2', 'opacity-0', 'group-hover:opacity-100', 'group-hover:translate-x-0'];

  function init(root) {
    if (root.hasAttribute('data-gc-ready')) return;
    root.setAttribute('data-gc-ready', '');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gc-tab]'));
    if (!tabs.length) return;
    var nameEl = root.querySelector('[data-gc-name]');
    var bodyEl = root.querySelector('[data-gc-bodytext]');
    var recEl = root.querySelector('[data-gc-rec]');
    var ctaEl = root.querySelector('[data-gc-cta]');
    var ctaTextEl = root.querySelector('[data-gc-cta-text]');
    var current = 0;

    function render() {
      tabs.forEach(function (t, i) {
        var on = i === current;
        var num = t.querySelector('[data-gc-num]');
        var arrow = t.querySelector('[data-gc-arrow]');
        var icon = t.querySelector('[data-gc-icon]');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (desktop.matches) {
          t.removeAttribute('aria-expanded');
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        } else {
          t.removeAttribute('aria-pressed');
          t.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
        t.classList.toggle('bg-graphite', on);
        t.classList.toggle('text-graphite-foreground', on);
        t.classList.toggle('hover:bg-surface', !on);
        if (num) {
          num.classList.toggle('text-primary', on);
          num.classList.toggle('text-muted-foreground', !on);
        }
        if (arrow) {
          ACTIVE_ARROW.forEach(function (c) { arrow.classList.toggle(c, on); });
          IDLE_ARROW.forEach(function (c) { arrow.classList.toggle(c, !on); });
        }
        if (icon) {
          icon.classList.toggle('text-primary', on);
          icon.classList.toggle('text-muted-foreground', !on);
        }
        if (panel) panel.hidden = !on;
      });
      var tab = tabs[current];
      if (!tab) return;
      if (nameEl) nameEl.textContent = tab.getAttribute('data-name');
      if (bodyEl) bodyEl.textContent = tab.getAttribute('data-body');
      if (recEl) recEl.textContent = tab.getAttribute('data-rec');
      if (ctaEl) ctaEl.setAttribute('href', tab.getAttribute('data-cta-link') || '#cta');
      if (ctaTextEl) ctaTextEl.textContent = tab.getAttribute('data-cta-text') || 'Configure This Build';
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (desktop.matches) {
          current = i;
        } else {
          current = current === i ? -1 : i;
        }
        render();
        if (!desktop.matches && current === i) {
          var top = t.getBoundingClientRect().top;
          var offset = 96;
          if (top < offset) window.scrollBy({ top: top - offset, behavior: 'smooth' });
        }
      });
    });

    desktop.addEventListener('change', function () {
      if (desktop.matches && current < 0) current = 0;
      render();
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-gc]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
